import Typography from "../../../../../../../../common/Typography";

const MembershipVisit = ({ activity, currencyView }) => {
  return (
    <div className="membership-coupon-redeemed-card">
      <div className="custom-row">
        <div className="left-side">
          <Typography size="heading-sm" weight="medium" customClass="gray-text">
            Made Visit
          </Typography>
          <Typography
            size="heading-lg"
            weight="medium"
            customClass="coupon-name"
          >
            {activity?.points_earned} Loyalty points earned
          </Typography>
          <Typography size="heading-sm" customClass="gray-text">
            {activity?.date_time}
          </Typography>
        </div>
        <div className="right-side">
          <Typography size="heading-lg" weight="medium">
            {currencyView}
            {activity?.bill_amount}
          </Typography>
          <Typography size="heading-sm" customClass="gray-text">
            {activity?.store_name}
          </Typography>
        </div>
      </div>
      <div className="items-row">
        {activity?.items?.map((item, i) => (
          <Typography size="text-xs" key={item?.id || i}>
            {item.name} ({item.quantity})
          </Typography>
        ))}
      </div>
    </div>
  );
};

export default MembershipVisit;
